/** @publicapi @module resolve */ /** */
export * from './interface';
export * from './resolvable';
export * from './resolveContext';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/@uirouter/core/lib-esm/resolve/index.js